"use client"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      // Arriba a la derecha, y acá una sola vez (regla de Denis, 2026-09-09).
      // Abajo a la derecha el aviso se apilaba sobre el compositor del chat y
      // sobre el botón flotante de Sol: verificando la nota de voz, el clic al
      // botón de enviar lo terminaba recibiendo el toast.
      position="top-right"
      // La barra superior mide `--topbar-h`; sin el desplazamiento el aviso
      // le queda encima y tapa la navegación mientras dura.
      offset={{ top: "calc(var(--topbar-h) + 0.75rem)" }}
      mobileOffset={{ top: "calc(var(--topbar-h) + 0.5rem)", left: "0.5rem", right: "0.5rem" }}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
